import { useQuery } from '@tanstack/react-query';
import {
  getRecordIdentifierSchema,
  getRecordIdentifiers,
  IInstanceIdentifierSchema,
  IInstanceIdentifierValues,
  TIdentifierRecordType,
} from 'src/api/recordIdentifiers';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

/** Five minutes, as the other reference data on these pages uses. */
const staleTime = 5 * 60 * 1000;

/**
 * The identifier keys the brand can set on a record of this type.
 *
 * Called twice on a record page, once by the page to decide whether the Integrations tab
 * exists at all and once by the tab itself. React Query serves the second from cache, so
 * it is one request.
 */
export const useRecordIdentifierSchema = (recordType: TIdentifierRecordType) =>
  useQuery({
    queryKey: [QueryKeys.recordIdentifierSchema, getBrandId(), recordType],
    queryFn: () => getRecordIdentifierSchema(recordType),
    staleTime,
    select: ({ data }): IInstanceIdentifierSchema[] => data,
  });

/**
 * The identifiers currently held against one record.
 *
 * @param recordType - The record type
 * @param recordId - The record, when there is one. The query waits until there is
 */
export const useRecordIdentifiers = (recordType: TIdentifierRecordType, recordId?: string) =>
  useQuery({
    queryKey: [QueryKeys.recordIdentifiers, getBrandId(), recordType, recordId],
    queryFn: () => getRecordIdentifiers(recordType, recordId as string),
    enabled: !!recordId,
    select: ({ data }): IInstanceIdentifierValues[] => data,
  });
